export default class Base64ImageUtils {
  static toFile(base64Image: string, fileName: string): File {
    const byteArraysWithContentType = Base64ImageUtils.toByteArraysWithContentType(base64Image);

    return new File(byteArraysWithContentType.byteArrays, fileName, { type: byteArraysWithContentType.contentType });
  }

  static toByteArraysWithContentType(base64Image: string): {
    contentType: string;
    byteArrays: Array<Uint8Array>;
  } {
    const contentTypeAndImagePart = Base64ImageUtils.extractContentTypeAndImagePart(base64Image);

    return {
      contentType: contentTypeAndImagePart.contentType,
      byteArrays: Base64ImageUtils.toByteArrays(contentTypeAndImagePart.imagePart),
    };
  }

  static extractContentTypeAndImagePart(base64Image: string): {
    contentType: string;
    imagePart: string;
  } {
    const contentTypeRegEx = /^data:(.*);/;
    const base64ImageArr = base64Image && base64Image.split(',');
    const contentTypeMatch = contentTypeRegEx.exec(base64ImageArr[0]);

    return {
      contentType: contentTypeMatch[1],
      imagePart: base64ImageArr[1],
    };
  }

  static toByteArrays(base64string: string): Array<Uint8Array> {
    const sliceSize = 1024;
    const byteCharacters = atob(base64string);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; sliceIndex += 1) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);

      const bytes = new Array(end - begin);
      for (let offset = begin, i = 0; offset < end; i += 1, offset += 1) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }

    return byteArrays;
  }
}
